import $ from "jquery";

var eshopOrder = {

	init: function() {
		var $this = this;

		// JS obsluhujici vyber dopravy a platby
		$("#shipping_payment_form input").change(function() {
			$this.checkPaymentShippingRadioButtons();
		});
		$this.checkPaymentShippingRadioButtons();

		// Order submit error
		// upozorneni na nezaskrtnuty souhlas pred odeslanim objednavky
		$(".orderSubmitError .close").click(function(event) {
			event.preventDefault();
			// Zavře aktuálně otevřený iziModal (pokud existuje)
			$('.iziModal:visible').iziModal('close');
			$('html, body').animate({
				scrollTop: $("#confirm_checkbox").offset().top - 40
			}, 2000);
		});

		// ochrana pred vicenasobnym odeslanim objednavky
		$("#order_submit").submit(function(event) {
			$("#order_submit .order-continue").attr("disabled", "disabled");
		});

		// odeslani obsahu kosiku na pozadi pred prechodem na dalsi stranku
		// nejak uplne nechapu princip :-)
		// Order continue
		$(".order-continue").click(function(event) {
			const url = $(this).attr("href");
			$(".order_item_count").each(function() {
				const input = $(this).find("input[name='count']");
				if (input.val() != input.attr("count")) {
					let formData = $(this).serialize();
					formData = formData + "&ajax=1";
					$.ajax({
						type: 'POST',
						url: url,
						data: formData,
						async: false
					});
				}
			});
		});
	},

	/**
	 * Prepina/nastavuje jako disabled checkboxy ve vyberu dopravy a platby
	 */
	checkPaymentShippingRadioButtons: function () {
		const person = $('#shippingMethod-personal').is(':checked');

		$("#paymentMethod-cash").attr('disabled', !person);
		$("#paymentMethod-delivery").attr('disabled', person);
		$("#paymentMethod-invoice").attr('disabled', person);

		if (person) {
			if ($('#paymentMethod-delivery').is(':checked') || $('#paymentMethod-invoice').is(':checked')) {
				$("#paymentMethod-delivery").prop('checked', false);
				$("#paymentMethod-invoice").prop('checked', false);
				$("#paymentMethod-cash").prop('checked', true);
			}
		} else {
			if ($('#paymentMethod-cash').is(':checked')) {
				$("#paymentMethod-cash").prop('checked', false);
				$("#paymentMethod-delivery").prop('checked', true);
			}
		}

		let shipping = $("#shipping_payment_form input[name=shippingMethod]:checked").val();
		let payment = $("#shipping_payment_form input[name=paymentMethod]:checked").val();

		if (shipping && payment) {
			let i = shipping.indexOf('#');
			if (i > 0) {
				shipping = shipping.substr(0, i);
			}
			i = payment.indexOf('#');
			if (i > 0) {
				payment = payment.substr(0, i);
			}

			if (typeof charge_enabled_shipping != 'undefined' && typeof charge_enabled_payments != 'undefined') {
				$(".charge_checkbox").each(function() {
					const id = $(this).attr('chargeid');
					$(this).prop('checked', charge_enabled_shipping['enabled_' + id].includes(shipping) && charge_enabled_payments['enabled_' + id].includes(payment));
				});
			}
		}
	}


};

$(function (){
	eshopOrder.init();
});

